import SurveyFeedbackBody from "components/SurveyComponents/SurveyFeedback/SurveyFeedbackBody/SurveyFeedbackBody";

const SurveyFeedback = () => {
  return <SurveyFeedbackBody />;
};

export default SurveyFeedback;
